export default __webpack_public_path__ + "static/Poppins-ThinItalic-9d5e661e645ce9a32fe63403feb904f2.ttf";